<template>
    <span v-if="value == 1" class="badge bg-success">{{ yesValue ? yesValue : translate.yes }}</span>
    <span v-else class="badge bg-danger">{{ noValue ? noValue : translate.not }}</span>
</template>

<script>
export default {
    props: ['value', 'yesValue', 'noValue', 'translate'],
    mounted() {
    }
}
</script>
